import { create } from 'zustand';

/**
 * Tasks this person just made appear — created, or put back on the board —
 * so a page shows them at once, even while it holds other arrivals, and
 * without marking them as news (spec 126 FR-005, spec 148). Memory only: it
 * matters for seconds.
 */
interface OwnTaskIdsState {
  ids: ReadonlySet<string>;
  add: (id: string) => void;
  forget: (id: string) => void;
}

export const useOwnTaskIds = create<OwnTaskIdsState>((set) => ({
  ids: new Set(),
  add: (id) => {
    set((state) => ({ ids: new Set(state.ids).add(id) }));
  },
  forget: (id) => {
    set((state) => {
      if (!state.ids.has(id)) return state;
      const next = new Set(state.ids);
      next.delete(id);
      return { ids: next };
    });
  },
}));
